export default "__VITE_ASSET__ByrvKDb1__"